module.exports = __webpack_public_path__ + "media/assets/images/blog/integrare_microsoft_365-7b02b5430c20f4b7df8cbfbc0268bed6.png";